import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForgotPasswordComponent } from './core/components/forgot-password/forgot-password.component';
import { LoginComponent } from './core/components/login/login.component';
import { ResetPasswordComponent } from './core/components/reset-password/reset-password.component';
import { AuthGuard } from './core/guards/auth.guard';
import { RedirectGuard } from './core/guards/redirect.guard';
import { PrivateLayoutComponent } from './core/layout/private-layout/private-layout.component';
import { PublicLayoutComponent } from './core/layout/public-layout/public-layout.component';

const routes: Routes = [
  {
    path: '',
    component: PublicLayoutComponent,
    canActivate: [RedirectGuard],
    children: [
      {
        path: '',
        component: LoginComponent
      }
      ,
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
      },
    ]
  }
  ,
  {
    path: '',
    component: PrivateLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'reporting',
        loadChildren: () => import('./reporting/reporting.module').then(m => m.ReportingModule)
      },
      {
        path: 'generic',
        loadChildren: () => import('./generic/generic.module').then(m => m.GenericModule)
      },
      {
        path: 'pos',
        loadChildren: () => import('./pos/pos.module').then(m => m.PosModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
